const formControlModalCloneCheckSite = {
  from: 'CLONAR DE:',
  to: 'CLONAR PARA:',
  text: 'SELECIONE OS TIPOS DE SERVIÇO QUE DESEJA CLONAR:'
};

export default formControlModalCloneCheckSite;
